import React from 'react';
import './PageHeader.css';
import { Link } from 'react-router-dom';

const PageHeader = ({ icon, title, subtitle, breadcrumb }) => {
  return (
    <div className="page-header">
      <div className="header-icon">{icon}</div>
      <h1 className="header-title">{title}</h1>
      {subtitle && <p className="header-subtitle">{subtitle}</p>}

      {breadcrumb && (
        <nav className="breadcrumb">
          {breadcrumb.map((item, index) => (
            <span key={index}>
              {item.link ? (
                <Link to={item.link} className="breadcrumb-link">
                  {item.label}
                </Link>
              ) : (
                <span className="breadcrumb-current">{item.label}</span>
              )}
              {index < breadcrumb.length - 1 && <span className="breadcrumb-separator">/</span>}
            </span>
          ))}
        </nav>
      )}
    </div>
  );
};

export default PageHeader;
